import React from "react";
import { useContext, useState } from "react";
import Contexto from "../context/Contexto";
import "../assets/css/Home.css";
import "../assets/css/Login.css";
import Registro from "../components/Registro";
import RegistroDos from "../components/RegistroDos";
import { useEffect } from "react";
function DGFsbGVyZXNhY29sb3I() {
  const { cursoscomprados, seteos, usuario, dameMiCurso, cliente } =
    useContext(Contexto);
  const [uid, setUid] = useState(null);
  let username = false;
  useEffect(() => {
    console.log("algo cambio en usuario");
    if (usuario) {
      username = usuario.username;
      setUid(usuario.uid);
    } else {
      setUid(null);
    }
  }, [usuario]);
  useEffect(() => {
    console.log("cursoscomprados", cursoscomprados);

    if (cursoscomprados.hasOwnProperty("color-club")) {
    } else {
      console.log("Nooooooo lo tiene");
      if (usuario) {
        dameMiCurso({ pibe: usuario.uid, cursin: ["color-club"] });
      }
    }
  }, [cursoscomprados, usuario]);
  return (
    <>
      <section className="home ">
        <div className="soporteLogin">
          <div className="login">
            <div className="login__wrapper centradoCompra">
              <br />
              <br />
              <img src={Carita} alt="" />
              <p className="titFelicitaciones">¡Gracias por sumarte!</p> <br />
              <br />
              <p class="datita">
                Dentro de MIS CURSOS podés encontrar <br /> todo el contenido de{" "}
                <br /> Color Club
              </p>
              <br />
              <Link to="miscursos" className="formuBT">
                MIS CURSOS
              </Link>
              <br />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default DGFsbGVyZXNhY29sb3I;
